import { Component, OnInit, Input } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { NavigationService } from '../services/navigation.service';
import { Store } from '@ngrx/store'; // Import Store from @ngrx/store
import { first } from 'rxjs/operators';
import { AppState } from '../app-reducer';
import { Observable } from 'rxjs';

@Component({
  selector: 'error-blank-application',
  templateUrl: './error-blank-application.component.html',
  styles: []
})
export class ErrorBlankApplicationComponent implements OnInit {
  @Input() role: string;
  chromeURL = 'https://www.google.com/chrome/';
  fireFoxURL = 'https://www.mozilla.org/en-US/firefox/new/';
  appId: string;
  appState$: Observable<any>;

  constructor(
    private newRelicService: NewRelicService,
    private navigationService: NavigationService,
    private store: Store<AppState> // Inject the store
  ) {
    this.appState$ = store.select('sections');
  }

  ngOnInit() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;

      this.newRelicService.addPageAction('ngOnInit error blank app', { status: 'error', appId: this.appId });
      
    });
  }

  goToCustomerAuthPage($event): void {
    try {
      this.newRelicService.addPageAction('goToCustomerAuthPage', { status: 'goToCustomerAuthPage Redirect', appId: this.appId });
      // determine which section
      $event.preventDefault();
      console.log('Going to customer authentication page.');
      this.navigationService.nextSectionRelative('find-application');
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }
}
